import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactDetails from "./sections/ContactDetails";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactDetails />
    </div>;
}